<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: ['prop_edit'],
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            form: {
                id: '',
                name: '',
                date: '',
                user_id: '',
                bank_id: '',
                id_ini: '',
                id_end: '',
                bank_account_id: '',
                status: 1,
            }
        }
    },
    methods: {
        async getBankCompany() {
            let company_id = this.form.company_id;
            let bank_id = this.form.bank_id;
            if (company_id && bank_id) {
                this.catalogue.getBankCompany(company_id, bank_id);
            }else{
                this.catalogue.bank_company = [];
            }
        },
        closedModal() {
            this.send = false;
            this.form.id = '';
            this.form.name = '';
            this.form.date = '';
            this.form.user_id = '';
            this.form.bank_id = '';
            this.form.id_ini = '';
            this.form.id_end = '';
            this.form.bank_account_id = '';
            this.form.status = 1;
            this.$modal.hide('addCheckbook');
        },
        async saveBuildings() {
            this.send = true;
            let form = this.form;
            // console.log(form);
            let _endpoint = '/checkbook';
            if (form.id != "") {
                form._method = 'PUT';
                _endpoint = `/checkbook/${form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, form)
                if (data) {
                    // this.users = data.data;
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-checkbook');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                    this.send = false;
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.catalogue.get_users_profiles('1,4');
        this.catalogue.get_companies_all();
        this.catalogue.get_banks();
    },
    created() {
        Event.$on("event-show-addCheckbook", (checkbook) => {
            // console.log(checkbook);
            if (checkbook.id) {
                this.form.id = checkbook.id;
                this.form.name = checkbook.name;
                this.form.date = checkbook.date;
                this.form.user_id = checkbook.user_id;
                this.form.bank_id = checkbook.bank_id;
                this.form.id_ini = checkbook.id_ini;
                this.form.id_end = checkbook.id_end;
                this.form.status = checkbook.status;
                this.form.bank_account_id = checkbook.bank_account_id;
                this.form.company_id = checkbook.company_id;
                this.getBankCompany();
            }
            this.$modal.show('addCheckbook');
        });
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="addCheckbook" :width="'80%'" :height="'auto'">
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Chequera</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4 mt-2">
                        <label>Nombre :</label>
                        <input type="text" class="form-control" v-model="form.name" :disabled="!prop_edit">
                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
                    </div>
                  
                    <div class="col-md-4 mt-2">
                        <label>Empresa :</label>
                        <select type="text" class="form-control" v-model="form.company_id" :disabled="!prop_edit" @change="getBankCompany()">
                            <option value="">Sin Empresa</option>
                            <option v-for="(company, index) in catalogue.companies_all" :value="company.id"
                                :key="index">
                                {{ company.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-4 mt-2">
                        <label>Banco :</label>
                        <select type="text" class="form-control" v-model="form.bank_id" :disabled="!prop_edit" @change="getBankCompany()">
                            <option value="">Sin Banco</option>
                            <option v-for="(nack, index) in catalogue.banks" :value="nack.id" :key="index">
                                {{ nack.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_id" class="text-danger">{{ errors.bank_id[0] }}</div>
                    </div>
                    <div class="col-md-4 mt-2">
                        <label>Cuenta bancaria :</label>
                        <select type="text" class="form-control" v-model="form.bank_account_id" :disabled="!prop_edit">
                            <option value="">Sin Cuenta</option>
                            <option v-for="(account, index) in catalogue.bank_company" :value="account.id" :key="index">
                                {{ account.number }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_account_id" class="text-danger">{{ errors.bank_account_id[0] }}</div>
                    </div>
                    <div class="col-md-4 mt-2">
                        <label>Usuario :</label>
                        <select type="text" class="form-control" v-model="form.user_id" :disabled="!prop_edit">
                            <option value="">Sin Usuario</option>
                            <option v-for="(user, index) in catalogue.users_profiles" :value="user.id" :key="index">
                                {{ user.name }} {{ user.last_name }}</option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>
                  

                    <div class="col-md-4 mt-2">
                        <label>Fecha :</label>
                        <date-picker v-model="form.date" valueType="format" :disabled="!prop_edit"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>ID inicio</label>
                        <input type="number" class="form-control" v-model="form.id_ini" :disabled="!prop_edit">
                        <div v-if="errors && errors.id_ini" class="text-danger">{{ errors.id_ini[0] }}</div>
                    </div>
                    <div class="col-md-4 mt-2">
                        <label>ID fin</label><br>
                        <input type="number" class="form-control" v-model="form.id_end" :disabled="!prop_edit">
                        <div v-if="errors && errors.id_end" class="text-danger">{{ errors.id_end[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Estatus :</label><br>
                        <button 
                            :disabled="!prop_edit"
                            type="button"
                            @click="form.status = form.status == 1 ? 0 : 1"
                            class="btn btn-block" 
                            :class="form.status == 1 ? 'btn-outline-success' : 'btn-outline-danger'">
                            <span v-if="form.status == 1">
                                <i class="fa-solid fa-power-off"></i> Activa
                            </span>
                            <span v-else>
                                <i class="fa-solid fa-power-off"></i> Inactiva
                            </span>

                        </button>
                    </div>


                    <div class="col-md-12">
                        <hr>
                        <button :disabled="send" type="submit" class="btn float-right btn-outline-success"
                            v-if="prop_edit">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>